import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — straight railing. Runs along the X axis through the tile
// centre, exactly one tile (1 m) long, so consecutive railing tiles form a
// continuous run; rotate in 90-degree steps to orient. Matte-black frame
// with a glass infill panel, handrail at 1.0 m.
const BLACK = "#2e2e30";
const GLASS = "#9fc4d4";

export const railingStraight = defineModel({
  id: "railing-straight",
  batchId: "modern",
  name: "Railing",
  tags: ["modern", "interior", "outdoor", "structure", "railing"],
  summary: "A 1 m modern glass-panel railing with a matte-black frame.",
  description:
    "The straight railing of the Modern Living kit: 1 m long along X " +
    "through the tile centre, matte-black posts and handrail at 1.0 m with " +
    "a glass infill panel. Chain tiles for longer runs; rotate 90 degrees " +
    "to orient.",
  tiles: { w: 1, h: 1 },
  footprint: 0.9,
  parts(): Part[] {
    return [
      // End posts.
      { geometry: new THREE.BoxGeometry(0.05, 1.0, 0.05), color: BLACK, position: [-0.475, 0.5, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 1.0, 0.05), color: BLACK, position: [0.475, 0.5, 0] },
      // Handrail at 1.0 m.
      { geometry: new THREE.BoxGeometry(1.0, 0.05, 0.06), color: BLACK, position: [0, 1.0, 0] },
      // Bottom rail.
      { geometry: new THREE.BoxGeometry(0.9, 0.04, 0.05), color: BLACK, position: [0, 0.08, 0] },
      // Glass infill panel.
      { geometry: new THREE.BoxGeometry(0.9, 0.86, 0.02), color: GLASS, position: [0, 0.53, 0] },
    ];
  },
  animations: [],
});
